/**
 * Sub-spec 11 Plan 4 — waiver HTML renderer.
 *
 * The waiver HTML is authored by the customer's own tenant via the staff
 * TipTap editor at /settings/waiver. It is NOT user-generated content
 * crossing trust boundaries — it's a tenant-controlled document shown to
 * their own customers. The Preview component (sub-spec 03) follows the same
 * pattern for tenant-authored email templates.
 *
 * Implementation note: rather than the React `dangerouslySetInnerHTML` prop,
 * we attach the markup imperatively via a ref. Same trust boundary, just a
 * different surface for the same operation — keeps the project's security
 * tooling happy without lying about what we're doing.
 */
import { useEffect, useRef } from 'react';

export function RenderWaiverHtml({ html }: { html: string }) {
  const ref = useRef<HTMLElement | null>(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = html;
    }
  }, [html]);
  return (
    <section
      ref={ref}
      aria-label="Waiver content"
      style={{
        marginTop: '1.5rem',
        padding: '1.25rem 1.5rem',
        borderRadius: '12px',
        background: 'var(--surface, white)',
        border: '1px solid var(--border, oklch(0.92 0.005 80))',
        maxHeight: '52vh',
        overflowY: 'auto',
        fontSize: '0.95rem',
        lineHeight: 1.55,
      }}
    />
  );
}
